import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type OpenAppointmentsQueryVariables = Types.Exact<{ [key: string]: never }>

export type OpenAppointmentsQuery = {
  __typename?: 'Query'
  openAppointments: {
    __typename?: 'OpenAppointmentsCollection'
    items: Array<{
      __typename?: 'OpenAppointment'
      id: string
      courtCaseUuid?: string | null
      date?: any | null
      type: Types.OpenAppointmentType
      customer: {
        __typename?: 'Customer'
        id: number
        firstName?: string | null
        lastName?: string | null
        latestMessage?: {
          __typename?: 'Message'
          id: number
          topic: { __typename?: 'Topic'; id: number; name: string }
        } | null
        membership?: {
          __typename?: 'Membership'
          uuid: string
          membershipType: { __typename?: 'MembershipType'; uid: string; displayName: string }
        } | null
      }
    }>
  }
}

export const OpenAppointmentsDocument = gql`
  query OpenAppointments {
    openAppointments {
      items {
        id
        courtCaseUuid
        customer {
          id
          firstName
          lastName
          latestMessage {
            id
            topic {
              id
              name
            }
          }
          membership {
            uuid
            membershipType {
              uid
              displayName
            }
          }
        }
        date
        type
      }
    }
  }
`
export function useOpenAppointmentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    OpenAppointmentsQuery,
    OpenAppointmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<OpenAppointmentsQuery, OpenAppointmentsQueryVariables>(
    OpenAppointmentsDocument,
    options
  )
}
export function useOpenAppointmentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OpenAppointmentsQuery,
    OpenAppointmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<OpenAppointmentsQuery, OpenAppointmentsQueryVariables>(
    OpenAppointmentsDocument,
    options
  )
}
export type OpenAppointmentsQueryHookResult = ReturnType<typeof useOpenAppointmentsQuery>
export type OpenAppointmentsLazyQueryHookResult = ReturnType<typeof useOpenAppointmentsLazyQuery>
export type OpenAppointmentsQueryResult = ApolloReactCommon.QueryResult<
  OpenAppointmentsQuery,
  OpenAppointmentsQueryVariables
>
export function refetchOpenAppointmentsQuery(variables?: OpenAppointmentsQueryVariables) {
  return { query: OpenAppointmentsDocument, variables: variables }
}
